//** React Imports
import { useState, useEffect } from 'react'

// ** Configs
import themeConfig from '@configs/themeConfig'

// ** Store & Actions
import { handleSkin } from '@store/actions/layout'
import { useDispatch, useSelector } from 'react-redux'
import { colorVar } from 'constants/global';

export const useSkin = () => {

  // ** Store Vars
  const dispatch = useDispatch()
  const skinState = useSelector(state => state.layout.skin)
  // ** State
  const [skin, setSkin] = useState(() => {
    try {
      // ** Get from local storage by key
      const item = skinState ? skinState : window.localStorage.getItem('skin')
      // ** Parse stored json or if none return initialValue
      return item ? item : themeConfig.layout.skin
    } catch (error) {
      // ** If error also return initialValue
      console.error(error)
      return themeConfig.layout.skin
    }
  })

  // ** Return a wrapped version of useState's setter function
  const setValue = value => {
    try {
      // ** Allow value to be a function so we have same API as useState
      const valueToStore = value instanceof Function ? value(skin) : value
      // ** Set state
      setSkin(valueToStore)
      // ** Save to local storage
      dispatch(handleSkin(valueToStore))
      window.localStorage.setItem('skin', JSON.stringify(valueToStore))
    } catch (error) {
      // ** A more advanced implementation would handle the error case
      console.error(error)
    }
  }

  useEffect(() => {
    // ** Get Body Tag
    const element = window.document.body

    // ** Define classnames for skins
    const classNames = {
      dark: 'dark-layout',
      bordered: 'bordered-layout',
      'semi-dark': 'semi-dark-layout'
    }

    // ** Remove all classes from Body on mount
    element.classList.remove(...element.classList)

    // ** If skin is not light add skin class
    if (skin !== 'light') {
      element.classList.add(classNames[skin])
      document.documentElement.style.setProperty('--app-tableColor', colorVar.darkTable)
    } else {
      document.documentElement.style.setProperty('--app-tableColor', colorVar.primary)
    }
  }, [skin])

  return [skin, setValue]
}
